import Vue from "vue";
import Router from "vue-router";
import store from "../store";

//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router);

const routes = [
    {
        path: "/register",
        name: "register",
        component: () => import("../components/users/forms/RegisterForm.vue"),
    },
    {
        path: "/",
        name: "home",
        components: {
            default: () => import("../components/home/Index.vue"),
        },
    },
    {
        path: "/visao-geral",
        name: "overview",
        component: () =>
            import("../components/home/widgets/ClienteOverview.vue"),
    },
    {
        path: "/checklist",
        name: "checklist",
        component: () => import("../components/checklist/Checklists.vue"),
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("../components/account/profile.vue"),
    },
    {
        path: "/cnae",
        name: "cnae",
        component: () => import("../components/cnae/Cnae.vue"),
    },
    {
        path: "/clientes",
        name: "clientes",
        component: () => import("../components/clientes/Clientes.vue"),
    },
    {
        path: "/certidoes",
        name: "certidoes",
        component: () => import("../components/certidoes/Certidoes.vue"),
    },
    {
        path: "/certificados",
        name: "certificados",
        component: () => import("../components/certificados/Certificados.vue"),
    },
    {
        path: "/enquadramento",
        name: "enquadramento",
        component: () =>
            import("../components/enquadramento/Enquadramento.vue"),
    },
    {
        path: "/enquadramento/check",
        name: "enquadramento-check",
        component: () => import("../components/enquadramento/Check.vue"),
    },
    {
        path: "/departamentos",
        name: "departamentos",
        component: () =>
            import("../components/departamentos/Departamentos.vue"),
    },
    {
        path: "/tipos-de-servico",
        name: "tipos-de-servico",
        component: () => import("../components/servicos/TipoServicos.vue"),
    },
    {
        path: "/parceiros",
        name: "parceiros",
        component: () => import("../components/parceiros/Parceiros.vue"),
    },
    {
        path: "/orgaos",
        name: "orgaos",
        component: () => import("../components/processos/Orgaos.vue"),
    },
    {
        path: "/processos",
        name: "processos",
        component: () => import("../components/processos/Orgaos.vue"),
    },
    {
        path: "/processos/cartoes/:cliente_id/:tarefa_id",
        name: "cartao_processo",
        components: {
            default: () => import("../components/processos/Orgaos.vue"),
            modal: () => import("../components/tarefas/Cartoes.vue"),
        },
        meta: { modal: true, redirect: "processos" },
    },
    {
        path: "/autos-de-intimacao",
        name: "autos-de-intimacao",
        component: () =>
            import("../components/autos_de_intimacao/AutosDeIntimacao.vue"),
    },
    {
        path: "/alvaras",
        name: "alvaras",
        component: () => import("../components/alvaras/Alvaras.vue"),
    },
    {
        path: "/financeiro/vendas",
        name: "vendas",
        component: () => import("../components/financeiro/Vendas.vue"),
    },
    {
        path: "/indicacoes",
        name: "indicacoes",
        component: () => import("../components/indicacoes/Indicacoes.vue"),
    },
    {
        path: "/outros-documentos",
        name: "outros-documentos",
        component: () => import("../components/outros/Outros.vue"),
    },
    {
        path: "/procuracao-eletronica",
        name: "procuracao-eletronica",
        component: () =>
            import(
                "../components/procuracao_eletronica/ProcuracaoEletronica.vue"
            ),
    },
    {
        path: "/tarefas",
        name: "tarefas",
        component: () => import("../components/tarefas/Tarefas.vue"),
    },
    {
        path: "/tarefas/create",
        name: "tarefa-create",
        components: {
            default: () => import("../components/tarefas/Tarefas.vue"),
            modal: () => import("../components/tarefas/forms/CartaoCreate.vue"),
        },
        meta: { modal: true, redirect: "tarefas" },
    },
    {
        path: "/tarefas/cartoes/:cliente_id/:tarefa_id",
        name: "cartoes",
        components: {
            default: () => import("../components/tarefas/Tarefas.vue"),
            modal: () => import("../components/tarefas/Cartoes.vue"),
        },
        meta: { modal: true, redirect: "tarefas" },
    },

    {
        path: "/relatorios",
        name: "relatorios",
        component: () => import("../components/relatorios/Relatorios.vue"),
    },

    {
        path: "/comunicacao",
        name: "comunicacao",
        component: () => import("../components/comunicacao/Comunicacao.vue"),
    },

    {
        path: "/comunicacao",
        name: "comunicacao",
        component: () => import("../components/comunicacao/Comunicacao.vue")
    },

    {
        path: "/comunicacao-emails",
        name: "comunicacao-emails",
        component: () => import("../components/comunicacao/Emails.vue")
    },

    {
        path: "/comunicacao-ligacoes",
        name: "comunicacao-ligacoes",
        component: () => import("../components/comunicacao/Comunicacao.vue")
    },


    {
        path: "/usuarios",
        name: "users",
        component: () => import("../components/users/Users.vue"),
    },

    {
        path: "/subscription",
        name: "subscription",
        component: () => import("../components/subscription/Subscription.vue"),
    },

    {
        path: "/updateplan",
        name: "update_plan",
        component: () => import("../components/subscription/UpdatePlan.vue"),
    },

    {
        path: "*",
        name: "PageNotFound",
        component: () => import("../components/PageNotFound.vue"),
    },
];

const router = new Router({
    base: "/",
    routes,
    mode: "history",
});

// Obtém um contexto com todos os arquivos "router.js" de Module/BaseImovel
const requireModuleRouter = require.context(
    "./../../../Modules",
    true,
    /router\.js$/
);
requireModuleRouter.keys().forEach((fileName) => {
    const routerConfig = requireModuleRouter(fileName).default;

    if (
        routerConfig &&
        routerConfig.routes &&
        Array.isArray(routerConfig.routes)
    ) {
        router.addRoutes(routerConfig.routes);
    }
});

router.beforeEach((to, from, next) => {
    if ("serviceWorker" in navigator) {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/service-worker.js")
                .then((registration) => {
                    if (registration?.onupdatefound) {
                        console.log(
                            "Entrei no onupdatefound before",
                            registration
                        );
                    }

                    registration.update().then(() => {
                        if (registration?.waiting) {
                            self.dispatchEvent(new Event("waiting"));
                        }
                    });

                    if (registration?.onupdatefound) {
                        console.log(
                            "Entrei no onupdatefound after",
                            registration
                        );
                    }
                })
                .catch((error) => {
                    console.warn("Error registering service worker:");
                    console.warn(error);
                });
        }
    }

    store.dispatch("api/CANCEL_PENDING_REQUESTS");

    store.commit("current_route/setRoute", to);
    next();
});

export default router;
